import { SetStateAction } from "../types";

// function reconcileChildren(fiber: Fiber, elementsToParse: any) {
//   const elements = arrayfy(elementsToParse);
//   let index = 0;
//   let previousSibling: Fiber | undefined;
//   let newFiber: Fiber | undefined = fiber.child;
//   let newKeyToFiber: { [key: string]: Fiber } = {};
//   let newFibers = Array(elements.length);

//   while (index < elements.length || newFiber !== undefined) {
//     let element = elements[index];
//     let newFiberTag = newFiber?.type;
//     let oldFiberTag = element?.type;

//     if (newFiberTag === oldFiberTag) {
//       newFiber = newFiber!.sibling;
//     } else if (element != null) {
//       if (newFiber !== undefined) {
//         newFiber = placeNewFiberBefore(newFiber, element);
//       } else {
//         newFiber = createFiberFromElement(element, fiber);
//       }
//       if (element?.key) {
//         newKeyToFiber[element.key!] = newFiber;
//       }
//       newFibers[index] = newFiber;
//     } else {
//       if (newFiber !== undefined) {
//         newFiber = placeDeletedFiberBefore(newFiber);
//       }
//     }
//     if (newFiber !== undefined) {
//       newFiber.index = index;
//     }
//     if (previousSibling !== undefined) {
//       previousSibling.sibling = newFiber;
//     }
//     previousSibling = newFiber;
//     index++;
//   }
//   fiber.child = newFibers[0];
//   assignKeyToSiblings(newFibers, newKeyToFiber);
// }

// function placeNewFiberBefore(currentFiber: Fiber, element: JSX.Element) {
//   const newFiber = createFiberFromElement(element, currentFiber.parent);
//   newFiber.index = currentFiber.index;
//   newFiber.sibling = currentFiber;
//   return newFiber;
// }

// function placeDeletedFiberBefore(currentFiber: Fiber) {
//   deleteFiber(currentFiber);
//   const nextFiber = currentFiber.sibling;
//   currentFiber.sibling = undefined;
//   return nextFiber;
// }

// function assignKeyToSiblings(
//   newFibers: Fiber[],
//   newKeyToFiber: { [key: string]: Fiber }
// ) {
//   for (let i = 0; i < newFibers.length; i++) {
//     const fiber = newFibers[i];
//     if (fiber.key !== null) {
//       if (i + 1 < newFibers.length) {
//         let nextFiber: Fiber | undefined = newFibers[i + 1];
//         while (nextFiber !== null && nextFiber?.key == undefined) {
//           nextFiber = nextFiber?.sibling;
//         }
//         fiber.sibling = nextFiber;
//       } else {
//         fiber.sibling = undefined;
//       }
//       newKeyToFiber[fiber.key!] = fiber;
//     }
//   }
// }

// function findFiberWithSameKey(
//   fiber: Fiber | undefined,
//   key: string
// ): Fiber | undefined {
//   if (!fiber) return;

//   if (fiber.key === key) return fiber;

//   let siblingFiberWithSameKey = findFiberWithSameKey(fiber.sibling, key);
//   if (siblingFiberWithSameKey) return siblingFiberWithSameKey;

//   return findFiberWithSameKey(fiber.child, key);
// }

// function reconcile(fiber: Fiber, newChildren: Fiber) {
//   const current = fiber.alternate;
//   const children: Fiber[] = current?.props?.children || [];
//   const oldFibers =
//     children.length > 0 ? children : current?.child ? [current.child] : [];
//   const newFibers: Fiber[] = arrayfy(newChildren);
//   return reconcileChildren(newFibers, oldFibers, fiber);
// }

// const newKeys = new Map<Key, Fiber>();
// for (const item of newFibers) if (item.key) newKeys.set(item.key, item);

// const oldKeys = new Map<Key, Fiber>();
// for (const item of oldFibers) {
//   if (item.key) {
//     if (!newKeys.has(item.key)) {
//       deleteFiber(item);
//     } else {
//       oldKeys.set(item.key, item);
//     }
//   }
// }

// function isDeleted(fiber: Fiber) {
//   if (fiber.flag === DELETION) {
//     return true;
//   }
//   return false;
// }

export function depsChanged(
  a: readonly any[] | any[] | null | undefined,
  b: readonly any[] | any[] | null | undefined
): boolean {
  if (a == null || b == null) return true;
  return (
    a.length !== b.length ||
    b.some((arg: any, index: number) => !Object.is(arg, a[index]))
  );
}

export function has(item: string, search: string, position = 0) {
  return equals(item[position], search);
}

export function isArray<T = any>(newChildren: any): newChildren is T[] {
  return Array.isArray(newChildren);
}

export function isFn(value: any): value is Function {
  return equals(typeof value, "function");
}

export function isStr(value: any): value is string {
  return equals(typeof value, "string");
}

export function isNull(value: any): value is null {
  return equals(value, null);
}

export function isObj(value: any): value is object {
  return equals(typeof value, "object");
}

export function isTextNode(value: any): value is string | number {
  return isStr(value) || equals(typeof value, "number");
}

export function arrayfy<T>(newChildren: T | T[]): T[] {
  return isArray(newChildren) ? newChildren : [newChildren];
}

export function extractFn<T>(state: T, action: SetStateAction<T>) {
  return isFn(action) ? action(state) : action;
}

export function equals<T = any>(a: T, b: T): a is T & null {
  return a === b;
}

// export function same(newFiber: Fiber, oldFiber: Fiber) {
//   return (
//     newFiber &&
//     oldFiber &&
//     newFiber.type === oldFiber.type &&
//     newFiber.key === oldFiber.key
//   );
// }

export function isChildren(value: string) {
  return equals(value, "children");
}

export function length(value?: any): number {
  return value?.length || 0;
}

export const shallowEqual = <T = any>(newObj: T, oldObj: T) => {
  if (equals(newObj, oldObj)) {
    return true;
  }
  for (const key in newObj) {
    const newProp = newObj[key];
    const oldProp = oldObj[key];
    if (isChildren(key)) {
      return true;
    } else if (!equals(newProp, oldProp)) {
      // console.log("not igual", { newProp, oldProp });
      return false;
    }
  }
  return true;
};

export function fastRecursive<P, R>(
  rec: (params: P) => Generator<P, R, R>
): (param: P) => R {
  return function (param: P) {
    let stack = [rec(param)];
    let stackIndex = 0;
    let returnValue: R | undefined;
    while (stackIndex >= 0) {
      let env = stack[stackIndex];
      let ite = env.next(returnValue!);
      if (ite.done) {
        returnValue = ite.value;
        stack.pop();
        stackIndex--;
      } else {
        stack.push(rec(ite.value));
        stackIndex++;
      }
    }
    return returnValue!;
  };
}

type BatchCallback = () => void;

export const createBatch = () => {
  let _microtaskRef = 0;
  let _ref = 0;

  return {
    exec(cb: BatchCallback, time = 0, once = false) {
      function bump() {
        _ref++;
        _microtaskRef = _ref;
        cb();
      }
      if (_microtaskRef === _ref) {
        _microtaskRef++;
        if (!_ref && once) {
          bump();
        } else {
          setTimeout(bump, time);
        }
      }
    },
    get _ref() {
      return _ref;
    },
  };
};

const googol = 10 ** 10;
const base = googol - 33;
const modulus = googol - 27;

export const hashString = (str: string) => {
  let hash = 0,
    i = 0;

  // Iterate through each character in the string and update the hash value
  while (i < length(str)) {
    hash = (hash * base + str.charCodeAt(i++)) % modulus;
  }

  // Return the hash value as a hexadecimal string
  return "p" + hash;
};

export function requestAnimationFrameMod(callback: () => void) {
  return isFn(requestAnimationFrame) // Check if the `requestAnimationFrame` function is available
    ? requestAnimationFrame(callback)
    : isFn(queueMicrotask) // Check if the `requestAnimationFrame` function is available
    ? queueMicrotask(callback)
    : setTimeout(callback, 0); // If none of the above are available, fall back to using `setTimeout` with a delay of 0
}
